import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideRoomTimeLimitWarning } from '../../actions';
import FinalCountdown from './FinalCountdown';
import RoomTimeLimitWarningNotification from './RoomTimeLimitWarningNotification';
const RoomTimeLimitNotificationContainer = () => {
    const dispatch = useDispatch();
    const showWarning = useSelector((state) => state['features/room-time-limit']?.showWarningNotification || false);
    const showCountdown = useSelector((state) => state['features/room-time-limit']?.showCountdown || false);
    const countdownSeconds = useSelector((state) => state['features/room-time-limit']?.countdownSeconds || 10);
    console.log('🔔 [NOTIFICATION CONTAINER] showWarning:', showWarning, 'showCountdown:', showCountdown);
    return (React.createElement(React.Fragment, null,
        showWarning && (React.createElement(RoomTimeLimitWarningNotification, { onClose: () => dispatch(hideRoomTimeLimitWarning()) })),
        showCountdown && (React.createElement(FinalCountdown, { secondsRemaining: countdownSeconds }))));
};
export default RoomTimeLimitNotificationContainer;
